import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { LocationService } from '../../../@core/services/location.service';
import { Stop } from '../../../@core/models/live-route';
import { StopService } from '../../../@core/services/stop.service';
import { DatePipe } from '@angular/common';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { SectorService } from '../../../@core/services/sector.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'ngx-change-priority-modal',
  templateUrl: './change-priority-modal.component.html',
  styleUrls: ['./change-priority-modal.component.scss']
})
export class ChangePriorityModalComponent implements OnInit {
  public displayedColumns: string[] = ['Postal_Code', 'Priority', 'Route'];
  stops: Stop[];

  constructor(
    public apiProvider: ApiProvider,
    public _stopService: StopService,
    public _locationService: LocationService,
    public _sectorService: SectorService,
    private datePipe: DatePipe,
    public toastservice: ToastrService,
    public authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<ChangePriorityModalComponent>,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.stops = [];
    this._locationService.RouteID = this._stopService.RouteID;
    this.stops = this._stopService.selectedStops.reduce((arr, item) => {
      const exists = !!arr.find(
        (x) => x.Address.Postal_Code === item.Address.Postal_Code
      );
      if (!exists) {
        arr.push(item);
      }
      return arr;
    }, []);
  }

  public goBack(): void {
    this.dialogRef.close(false);
  }

  updateRoute(PostalCode, RouteID) {
    this.apiProvider
      .UpdateLocationRouteID(
        this._locationService.RouteID,
        RouteID,
        PostalCode
      )
      .subscribe(() => {
        this.toastservice.success(
          this.translate.instant('locations-update.transfert-route'),
          this.translate.instant('Changement effectué'),
          {
            positionClass: 'toast-bottom-left',
            disableTimeOut: false,
            enableHtml: true
          }
        );
      });
  }
}
